import { PreferredAngles } from "./preferredAngles";

export class Item {
    id: string;

    group: string;

    isPermanent: boolean;

    displayText?: string | null;

    retailerId?: string | null;

    preferredAngles?: PreferredAngles | null;

    constructor(
        id: string,
        group: string,
        displayText: string | null | undefined,
        retailerId: string | null | undefined,
        isPermanent: boolean,
        preferredAngles: PreferredAngles | null | undefined
    ) {
        this.id = id;
        this.group = group;
        this.isPermanent = isPermanent;
        this.displayText = displayText;
        this.retailerId = retailerId;
        this.preferredAngles = preferredAngles;
    }
}
